import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
	AnamneseActionTypes,
	ProductSelectedAction,
	SetAvailableBenefitsAction
} from "./anamnese.actions";
import { catchError, map, switchMap } from "rxjs";
import { ProductKey, ProductOptions } from "libs/product/src/lib/models/product.model";
import { BenefitService } from "libs/benefits/src/lib/services/benefit.lib.service";
import { BenefitName } from "libs/benefits/src/lib/models/benefit.model";

@Injectable({
	providedIn: "root"
})
export class AnamneseEffects {
	private actions$ = inject(Actions);
	private benefitService = inject(BenefitService);

	productSelected$ = createEffect(() =>
		this.actions$.pipe(
			ofType<ProductSelectedAction>(AnamneseActionTypes.ProductSelected),
			map((action) => action.payload),
			switchMap((payload: { key: ProductKey; options?: ProductOptions }) =>
				this.benefitService.getValidBenefitNamesForProductKey(payload.key)
			),
			map((benefits: BenefitName[]) => new SetAvailableBenefitsAction(benefits)),
			catchError(() => {
				console.error("Error fetching available benefit names");
				return [];
			})
		)
	);
}
